import type { ReactNode } from 'react'
import { Filter, RotateCcw } from 'lucide-react'
import { Button } from '@/shared/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/ui/popover'

interface FilterPopoverProps {
  title: string
  resetLabel: string
  activeCount?: number
  children: ReactNode
  onReset: () => void
}

export function FilterPopover({
  title,
  resetLabel,
  activeCount = 0,
  children,
  onReset,
}: FilterPopoverProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className="h-10 self-end">
          <Filter className="h-4 w-4" />
          {title}
          {activeCount > 0 && (
            <span className="ml-1 rounded-full bg-zinc-900 px-1.5 py-0.5 text-[11px] leading-none text-white">
              {activeCount}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[520px] max-w-[calc(100vw-2rem)] p-4">
        <div className="mb-4 flex items-center justify-between gap-3">
          <p className="text-sm font-semibold text-zinc-900">{title}</p>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="h-8 px-2 text-zinc-600"
            onClick={onReset}
          >
            <RotateCcw className="h-3.5 w-3.5" />
            {resetLabel}
          </Button>
        </div>

        <div className="grid gap-3 sm:grid-cols-2">{children}</div>
      </PopoverContent>
    </Popover>
  )
}
